module.exports = __webpack_public_path__ + "static/bg_home-mobile-4faa6fbd5073b6b0a542d34f13b1b6fc.jpg";